import React, { createContext, useContext, useState, useCallback, useEffect } from "react";

/**
 * Global voice preference (female=Yoko / male=Kenzo), persisted in localStorage.
 * Used by every page that plays Japanese audio through ElevenLabs.
 *
 * The DIALOGUE component in Lessons can override per-line (A=female, B=male) by
 * passing an explicit voice argument to useTTS().speak(text, voice).
 */
const STORAGE_KEY = "nihongo_voice_pref_v1";
const DEFAULT_VOICE = "female"; // Yoko by default

const VoiceContext = createContext({
  voice: DEFAULT_VOICE,
  setVoice: () => {},
});

export const VoiceProvider = ({ children }) => {
  const [voice, setVoiceState] = useState(DEFAULT_VOICE);

  // Load preference from localStorage on mount
  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored === "female" || stored === "male") setVoiceState(stored);
    } catch (_e) { /* SSR / privacy mode */ }
  }, []);

  const setVoice = useCallback((v) => {
    if (v !== "female" && v !== "male") return;
    setVoiceState(v);
    try { window.localStorage.setItem(STORAGE_KEY, v); } catch (_e) { /* noop */ }
  }, []);

  return (
    <VoiceContext.Provider value={{ voice, setVoice }}>
      {children}
    </VoiceContext.Provider>
  );
};

export const useVoice = () => useContext(VoiceContext);

export const VOICE_LABELS = {
  female: { name: "Atsuko", emoji: "👩🏻", desc: "Voix féminine native (Atsuko)" },
  male: { name: "Alexis", emoji: "👨🏻", desc: "Voix masculine native (Alexis)" },
};
